import { Phone, LifeBuoy, ArrowRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "./data";

export const Support = ({ onRequest }) => (
  <section id="support" data-testid="support-section" className="border-y border-brand-surface bg-white">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-14 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-start gap-5">
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-brand-offwhite"><LifeBuoy className="h-6 w-6 text-brand-blue" strokeWidth={1.6} /></span>
        <div>
          <p className="eyebrow">Support</p>
          <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-brand-navy">Already working with JMS?</h2>
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-brand-slate">Call us for help with a system we've installed, or send a support request and we'll follow up.</p>
        </div>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row">
        <a href={PHONE_HREF} data-testid="support-call-button" className="btn-primary">
          <Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}
        </a>
        <button type="button" onClick={onRequest} data-testid="support-request-button" className="btn-secondary">
          Send a Support Request <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  </section>
);
